export const isValidDate = (date: Date | null) => {
  return date instanceof Date && !isNaN(date.getTime());
};
